export default [
  {
    "key": "impact",
    "price": 11.15,
    "name": "Impact",
    "pricePerMonth": 11.15,
    "pricePerYear": 11.15,
  },
  {
    "id": 1,
    "key": "Exact_IPNUK",
    "onePlan": 0,
    "name": "exact ",
    "pricePerMonth": 22.90,
    "pricePerYear": 229,
    "systemCrops": 7,
    "personalCrops": 5,
    "plans": 45,
  },
  {
    "id": 2,
    "key": "Premium_IPNUK",
    "onePlan": 0,
    "name": "premium ",
    "pricePerMonth": 49,
    "pricePerYear": 529,
    "systemCrops": 20,
    "personalCrops": 5,
    "plans": 250,
  },
  {
    "id": 3,
    "key": "elite",
    "onePlan": 0,
    "name": "elite ",
    "pricePerMonth": 179.99,
    "pricePerYear": 1999,
    "systemCrops": 9999,
    "personalCrops": 5,
    "plans": 999999,
  }
]
